import { render, staticRenderFns } from "./yansheng.vue?vue&type=template&id=6c842063&scoped=true"
import script from "./yansheng.vue?vue&type=script&lang=js"
export * from "./yansheng.vue?vue&type=script&lang=js"
import style0 from "./yansheng.vue?vue&type=style&index=0&id=6c842063&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c842063",
  null
  
)

export default component.exports